<template>
    <content-ribbon :current-ribbon="componentProps.currentRibbon"
                    :post-action="componentProps.postAction"
                    :ribbon-item-from-api="componentProps.ribbonItemFromApi"
                    :is-previously-selected="componentProps.isPreviouslySelected"
                    :label-with-count="componentProps.labelWithCount"
                    :show-ribbon-checkbox-option="componentProps.showRibbonCheckboxOption"
                    :update-route="componentProps.updateRoute"
                    :apply-number-count="componentProps.applyNumberCount"
    ></content-ribbon>
</template>

<script>
    import ContentRibbon from "./ContentRibbon";

    export default {
        name: 'ContentCategory',
        components: { ContentRibbon },
        props: {
            componentProps: {
                type: Object,
                required: true,
            },
        },
    };
</script>
